import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/cn';
import type { NavItem } from './nav-items';
import { QuickAddSheet } from './QuickAddSheet';

function Tab({ item }: { item: NavItem | undefined }): JSX.Element | null {
  if (!item) return null;
  const Icon = item.icon;
  return (
    <NavLink
      to={item.path}
      end={item.path === '/'}
      className={({ isActive }) =>
        cn(
          'flex h-12 flex-1 flex-col items-center justify-center gap-0.5 text-[11px] transition-colors duration-150',
          isActive ? 'text-link' : 'text-muted-foreground hover:text-foreground',
        )
      }
    >
      <Icon className="h-4 w-4" aria-hidden="true" />
      {item.shortLabel}
    </NavLink>
  );
}

/**
 * Phone (< sm): the original bottom bar Home, Log, [+], Projects, Reports. No "More" tab: Settings,
 * Admin, theme and Sign out live in the hamburger drawer (SE decision).
 */
export function BottomTabBar({ items }: { items: NavItem[] }): JSX.Element {
  const tabs = items.filter((i) => i.phoneTab);
  return (
    <nav
      aria-label="Bottom navigation"
      className="fixed inset-x-0 bottom-0 z-30 flex items-stretch border-t border-border bg-card pb-[env(safe-area-inset-bottom)] sm:hidden"
    >
      <Tab item={tabs[0]} />
      <Tab item={tabs[1]} />
      <div className="flex flex-1 items-start justify-center">
        <QuickAddSheet />
      </div>
      <Tab item={tabs[2]} />
      <Tab item={tabs[3]} />
    </nav>
  );
}
